import { FileText, Info } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  getFilingDeadline,
  getMonthGenitive,
  getPreviousMonth,
} from '@/features/dashboard/tfg/types/month.ts';

interface TfgDeadlineBannerProps {
  onGenerate: () => void;
}

const TfgDeadlineBanner = ({ onGenerate }: TfgDeadlineBannerProps) => {
  const period = getPreviousMonth();
  const deadline = getFilingDeadline(period);
  const deadlineText = `21 ${getMonthGenitive(
    deadline.getMonth() + 1,
  )} ${deadline.getFullYear()}`;

  return (
    <div className="flex flex-col gap-3 rounded-md border border-accent-300 bg-accent-200 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <Info className="mt-0.5 size-5 shrink-0 text-accent-600" />
        <div className="space-y-0.5">
          <p className="text-sm font-medium text-base-text">
            Termin złożenia deklaracji TFG
          </p>
          <p className="text-sm text-neutral-700">
            Deklarację należy złożyć do 21. dnia miesiąca następującego po
            okresie sprawozdawczym. Deklarację za{' '}
            {getMonthGenitive(period.month)} {period.year} należy złożyć do{' '}
            {deadlineText}.
          </p>
        </div>
      </div>
      <ActionButton
        tone="accent"
        size="sm"
        onClick={onGenerate}
        className="shrink-0"
      >
        <FileText />
        Wygeneruj deklarację TFG
      </ActionButton>
    </div>
  );
};

export default TfgDeadlineBanner;
